module.exports = __webpack_public_path__ + "static/media/programacaoalapis-pesquisa.ca206c6e.png";